export enum GameFlow {
  welcome = 0,
  round = 1,
  question = 2,
  bonusSplash = 1,
  bonusQuestion = 2,
  ad = 3,
  leaderboard = 4,
  finish = 5,
  wager = 6,
  survey = 7
}
